import React from "react";
import { FaTimes } from "react-icons/fa";

export default function AdminInfoModal({
    isOpen,
    closeModal,
    modalData,
}) {
    if (!modalData) return null;

    const owner = modalData.owner || {};

    const fullName =
        `${owner.firstName || ""} ${owner.lastName || ""}`.trim();

    const phone =
        `${owner.countryCode || ""}${owner.phone || ""}`;

    return (
        <div
            className={`fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50 ${isOpen ? "block" : "hidden"
                }`}
        >
            <div className="p-6 rounded-lg max-w-[500px] w-full bg-white divide-y divide-gray-600">

                {/* Header */}
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-bold text-[#1B4748]">
                        اطلاعات بات {modalData.username || "-"}
                    </h3>

                    <button
                        onClick={closeModal}
                        className="text-red-500"
                    >
                        <FaTimes className="text-xl" />
                    </button>
                </div>

                {/* Information */}
                <div className="mt-4">

                    <p className="mb-2">
                        <strong>اسم و فامیل:</strong>{" "}
                        {owner.firstName + " " + owner.lastName || "-"}
                    </p>

                    <p className="mb-2 mt-2">
                        <strong>نام سازمان/مدیر:</strong>{" "}
                        {modalData.orgName ||
                            fullName ||
                            modalData.name ||
                            "-"}
                    </p>

                    <p className="mb-2">
                        <strong>ایمیل:</strong>{" "}
                        {owner.email || "-"}
                    </p>

                    <p className="mb-2">
                        <strong>تلفن:</strong>{" "}
                        {phone || "-"}
                    </p>

                    <p className="mb-2">
                        <strong>سایت:</strong>{" "}
                        {modalData.website || "-"}
                    </p>

                    <p className="mb-2 text-justify overflow-y-auto max-h-[7.5rem] whitespace-pre-wrap">
                        <strong>پرامپت سیستمی: </strong>
                        {modalData.prompt || "-"}
                    </p>

                    <p className="mb-2 text-justify overflow-y-auto max-h-[7.5rem] whitespace-pre-wrap">
                        <strong>آدرس دستیار :  </strong>
                        <a className="text-blue-600 underline" href={modalData.botUrl}>{modalData.botUrl || "-"}</a>
                    </p>

                    <p className="mb-2 text-justify overflow-y-auto max-h-[7.5rem] whitespace-pre-wrap">
                        <strong>تعداد مشتریان : </strong>
                        {modalData.customerCount || "-"}
                    </p>

                </div>
            </div>
        </div>
    );
}
